var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgStar = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m12.746 10.781.758 4.406a.374.374 0 0 1-.544.394L9.004 13.5l-3.957 2.081a.374.374 0 0 1-.543-.393l.757-4.407-3.21-3.12a.376.376 0 0 1 .206-.641l4.425-.641 1.98-4.009a.375.375 0 0 1 .672 0l1.98 4.009 4.425.641a.375.375 0 0 1 .206.641z" }) }))); };
export default SvgStar;
